import React, { Component } from 'react';

import Button from '../../../../common/Button/Button';
import Checkbox from '../../../../common/Checkbox/Checkbox';

import cn from 'classnames';
import styles from './Payment.scss';
import tracker from '../../../../../services/tracker';
import { withTranslation } from 'react-i18next';
import i18n from '../../../../../i18n';

const variants = {
  mrt: { param: 'mrt', key: 'ipoteka', text: i18n.t('components.header.filtersBar.filters.payment.ipoteka'), event: 'Web_Filters_Mortgage' },
  inst: { param: 'inst', key: 'installments', text: i18n.t('components.header.filtersBar.filters.payment.installments'), event: 'Web_Filters_Installment' },
  mil: { param: 'mil', key: 'military_ipoteka', text: i18n.t('components.header.filtersBar.filters.payment.military_ipoteka'), event: 'Web_Filters_Military_Mortgage' },
  capt: { param: 'capt', key: 'mat_capital', text: i18n.t('components.header.filtersBar.filters.payment.mat_capital'), event: 'Web_Filters_Maternity_Capital' }
};

export const parseSearch = (search) => {
  const { payment } = search;
  if (!payment) {
    return { payment: [] };
  }
  const keys = payment.split(',');
  return {
    payment: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.param)) {
          prev.push(variant.key);
        }
        return prev;
      }, [])
  };
};

export const compileSearch = (data) => {
  const { payment: keys } = data;
  if (!keys.length) {
    return { payment: undefined };
  }

  return {
    payment: Object.keys(variants)
      .reduce((prev, cur) => {
        const variant = variants[cur];
        if (keys.includes(variant.key)) {
          prev.push(variant.param);
        }
        return prev;
      }, [])
      .join(',') || undefined
  };
};

export const compileRequest = (data) => {
  const { payment } = data;
  return { paymentOptions: payment.length ? payment : undefined };
};

export const getRequest = (search) => compileRequest(parseSearch(search));

export const subtext = (search) => {
  const { payment: keys } = parseSearch(search);
  return Object.keys(variants)
    .reduce((prev, cur) => {
      const variant = variants[cur];
      if (keys.includes(variant.key)) {
        prev.push(variant.text);
      }
      return prev;
    }, [])
    .join(', ') || i18n.t('components.header.filtersBar.filters.payment.notSelected');
};

class Payment extends Component {

  constructor(props) {
    super(props);

    this.handleCheckboxClick = this.handleCheckboxClick.bind(this);
    this.handleClearClick = this.handleClearClick.bind(this);
  }

  handleClearClick() {
    const { dropdownData } = this.props;
    const data = { payment: [] };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
    this.props.onClearClick('payment');
  }

  handleCheckboxClick(key, add) {
    const { search, dropdownData, eventData } = this.props;
    const { payment: keys } = parseSearch(search);
    const payment = [...keys];

    tracker.sendVariantEvent({ variants, key, selected: add, eventData });

    if (payment.includes(key) !== add) {
      if (add) {
        payment.push(key);
      } else {
        payment.splice(payment.indexOf(key), 1);
      }
    }

    const data = { payment };
    const compiledSearch = compileSearch(data);
    const compiledRequest = compileRequest(data);
    dropdownData(compiledSearch, compiledRequest);
  }

  checkbox(key) {
    const { search, additional } = this.props;
    const { payment } = parseSearch(search);
    const variant = variants[key];
    return (
      <Checkbox
        className={styles.Checkbox}
        innerStyle={styles.FiltersCheckInner}
        classNameClone="CheckboxCloneFilters"
        checked={payment.includes(variant.key)}
        additional={additional}
        handle={this.handleCheckboxClick.bind(undefined, variant.key)}
        text={variant.text}
      />
    );
  }

  render() {
    const { className, additional, search, t } = this.props;
    const { payment } = parseSearch(search);

    return (
      <div className={cn(styles.Menu, className, { [styles.Additional]: additional })}>
        <p className={styles.Title}>
          {t('components.header.filtersBar.filters.payment.title')}
          {!additional ? (
              !!payment.length &&
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.payment.clear')}
              </Button>
          ) : (null)}
        </p>
        <div className={styles.Checkboxes}>
          <div className={styles.FirstColumn}>
            {this.checkbox('mrt')}
            {this.checkbox('inst')}
          </div>
          <div className={styles.SecondColumn}>
            {this.checkbox('mil')}
            {this.checkbox('capt')}
          </div>
        </div>
        {additional ? (
          <div className={styles.ButtonWrap}>
            {!!payment.length &&
              <Button className={styles.Button} onClick={this.handleClearClick}>
                {t('components.header.filtersBar.filters.payment.clear')}
              </Button>}
          </div>
        ) : (null)}
      </div>
    );
  }
}

export default withTranslation()(Payment);



// WEBPACK FOOTER //
// ./src/components/Header/FiltersBar/Filters/Payment/Payment.js